import PropTypes from 'prop-types'
import { Icon } from '@iconify/react'
import twitterFill from '@iconify/icons-eva/twitter-fill'
import linkedinFill from '@iconify/icons-eva/linkedin-fill'
import facebookFill from '@iconify/icons-eva/facebook-fill'
import instagramFilled from '@iconify/icons-ant-design/instagram-filled'
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill'
import { sentenceCase } from 'change-case'
// material
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles'
import { useTheme } from '@material-ui/core/styles'

import {
  Box,
  Card,
  Grid,
  Avatar,
  Tooltip,
  Divider,
  Stack,
  Typography,
  IconButton,
  AvatarGroup,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
  Checkbox,
} from '@material-ui/core'
// utils
import { fShortenNumber, fUSPrice } from 'src/utils/formatNumber'
import {
  getGroupedInvoiceDisplayNumbersText,
  getGroupedSalesOrderJobNumbersText,
} from 'src/utils/salesOrderDisplayNumbers'
//
import SvgIconStyle from 'src/components/SvgIconStyle'
import Label from 'src/components/Label'
import { useNavigate } from 'react-router'
import { PATH_DASHBOARD } from 'src/routes/paths'
import { Message, MessageSharp, RequestQuote, ShoppingBag, AccessTime, LocalOffer, CreditCard, EmojiEvents, Payment } from '@material-ui/icons'
import moment from 'moment'
import { getAgoString } from 'src/common/Helper'
import { useSnackbar } from 'notistack'
import { Link } from 'react-router-dom'
import { empty } from 'src/Helpers/Common'
import {
  PRESERVE_WHITESPACE_ELLIPSIS_SX,
  preserveWhitespaceTitle,
} from 'src/utils/preserveWhitespace'
import { COMPANY_LOGO, REST_API_END_POINT, FacilityTypes } from 'src/constants/Defaultvalues'
import QuickbookLogo from '../../../assets/quickbookLogo-removebg-preview.png'
import AVALARALOGO from '../../../assets/Avalara_Logo.png'
import { useState } from 'react'
import briefcaseFill from '@iconify/icons-eva/briefcase-fill';
import copyFill from '@iconify/icons-eva/copy-fill';
import AnimatedButton from "src/components/animate/AnimatedButton";
import { isAdminUser } from '../../../utils/adminUserTypes';
import FullScreenDialogEstimate from 'src/pages/components-overview/material-ui/dialog/FullScreenDialogEstimate'
import FullScreenDialogSalesOrder from 'src/pages/components-overview/material-ui/dialog/FullScreenDialogSalesOrder'
import { UserMoreMenu } from '../user/list'
import ConfirmationPopup from 'src/components/_dashboard/official-request/ConfirmationPopup'
import axios from 'axios'
import { blur } from 'd3-array'
import { SalesOrderNewBadge, getSalesOrderNewCardSx } from './SalesOrderNewBadge'

// ----------------------------------------------------------------------

const CardMediaStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  justifyContent: 'center',
  paddingTop: 'calc(100% * 9 / 16)',
  borderTopLeftRadius: theme.shape.borderRadiusMd,
  borderTopRightRadius: theme.shape.borderRadiusMd,
  overflow: 'hidden',
  '&:before': {
    top: 0,
    zIndex: 9,
    content: "''",
    width: '100%',
    height: '100%',
    position: 'absolute',
    //  backdropFilter: 'blur(3px)',
    WebkitBackdropFilter: 'blur(3px)', // Fix on Mobile
    borderTopLeftRadius: theme.shape.borderRadiusMd,
    borderTopRightRadius: theme.shape.borderRadiusMd,
    // backgroundColor: alpha(theme.palette.primary.darker, 0.72)
  },
}))

const CoverImgStyle = styled('img')({
  top: 0,
  zIndex: 8,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
  borderTopLeftRadius: 'inherit',
  borderTopRightRadius: 'inherit',
  //    background: `url(${src}) center/cover no-repeat`
})

// ----------------------------------------------------------------------

function InfoItem(number) {
  return (
    <Grid item xs={4}>
      <Typography
        variant="caption"
        sx={{ mb: 0.5, color: 'text.secondary', display: 'block' }}
      >
        Follower
      </Typography>
      <Typography variant="subtitle1">{fShortenNumber(number)}</Typography>
    </Grid>
  )
}

OfficialCard.propTypes = {
  card: PropTypes.object.isRequired,
  team_member: PropTypes.array.isRequired,
  communityRfqListState: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    clients: PropTypes.string,
  }),
  communityInstallsListState: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    clients: PropTypes.string,
  }),
}
const IconWrapperStyle = styled('div')(({ theme }) => ({
  width: 18,
  height: 18,
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: '4px',
  color: theme.palette.success.main,
  // backgroundColor: alpha(theme.palette.success.main, 0.16),
}));

export default function OfficialCard({
  card,
  team_member,
  communityId,
  communityRfqListState,
  CommunityInstalls,
  communityInstallsListState,
  clientId,
  communityName,
  CommunityProjects,
  quotationView,
  proposalView,
  designOrder,
  setRenderCards,
  renderCards,
  handleOpenViewSalesOrder,
  handleOpenDetailsSalesOrder,
  setOpenSalesOrder,
  opeSalesOrder,
  handleOpenViewEstimate,
  handleOpenDetails,
  SalesOrderId,
  setSalesOrderId,
  salesOrderName,
  setSalesOrderName,
  removePopupData,
  openPurchaseOrder,
  setOpenPurchaseOrder,
  PurchaseOrderName,
  purchaseOrderId,
  isEditPurchaseOrder,
  setIsEditPurchaseOrder,
  setPurchaseOrderId,
  setPurchaseOrderName,
  CommunityJob,
  communityDesignOrder,
  handleOpenDetailsPurchaseOrder,
  handleOpenViewPurchaseOrder,
  estimateNewCard,
  salesOrderNewCard,
  designOrderNewCard,
  currentTab,
  isSalesOrder,
  handleOpenViewDesignOrder,
  handleOpenDetailsDesignOrder,
  projectEstimate=false,
  hasViewCostPermission=true,
  onProposalAwardAction,
  awardActionLoadingId,
  showSelectionCheckbox = false,
  selectionChecked = false,
  onSelectionChange,
  onGroupedCardClick,
  isInvoiceGroupDialogItem = false,
  groupedParentRequestId = null,
  invoiceSequenceIndex = null,
  // handleOpenEstimate,setHandleOpenEstimate,estimateId,setEstimateId,estimateName,setEstimateName,isEditEstimate,setIsEditEstimate
}) {
  const communitySalesOrderNavigateState = {
    fromCommunitySalesOrder: true,
    ...(communityRfqListState ? { communityRfqListState } : {}),
  }
  const communityInstallsNavigateState = {
    fromCommunityInstalls: true,
    ...(communityInstallsListState ? { communityInstallsListState } : {}),
  }
  const communityJobNavigateState = CommunityInstalls
    ? communityInstallsNavigateState
    : communitySalesOrderNavigateState
  console.log('currentTabeeeeeeeeeeeeeeeee', hasViewCostPermission)
  const theme = useTheme()
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const [openHoldPopup, setOpenHoldPopup] = useState(false);
  const [holdReason, setHoldReason] = useState('');
  const [isSubmittingHold, setIsSubmittingHold] = useState(false);
  const [holdReasonError, setHoldReasonError] = useState('');
  const [openVoidPopup, setOpenVoidPopup] = useState(false);
  const [loadingVoid, setLoadingVoid] = useState(false);
  const [openReopenVoidPopup, setOpenReopenVoidPopup] = useState(false);
  const [loadingReopenVoid, setLoadingReopenVoid] = useState(false);
  const [voidReason, setVoidReason] = useState('');
  const [voidReasonError, setVoidReasonError] = useState('');
  let user = JSON.parse(localStorage.getItem('user'))
  let isClient =user?.isClient
  
  let userType =isClient ? 3 : user.user_type
  let userId = user.user_id

  if(user.added_by_client && user.parent_user_type && user.parent_id) {
    userId = user.parent_id
    userType = 3 //user.parent_user_type
  }
  
  const explodedPermissions = user?.exploded_permissions
  const handleOpenEstimateTemp = localStorage.getItem(
    'estimateOpenProductionPopup',
  )
  const [handleOpenEstimate, setHandleOpenEstimate] = useState(
    handleOpenEstimateTemp || false,
  )
  const [estimateId, setEstimateId] = useState(false)
  const [estimateName, setEstimateName] = useState(false)
  const [isEditEstimate, setIsEditEstimate] = useState(false)

  const [isEditSalesOrder, setIsEditSalesOrder] = useState('')
  const isGroupedInvoiceCard = isSalesOrder
    && !isInvoiceGroupDialogItem
    && Number(card?.is_grouped_request || 0) === 1
  const handleGroupedCardClick = (event) => {
    event?.stopPropagation?.()
    if (onGroupedCardClick) {
      onGroupedCardClick(card)
    }
  }
  const {
    image,
    message,
    timestamp,
    id,
    added_by_profile_pic,
    name,
    status,
    is_from_client,
    is_request_estimate,
    hold,
    design_order_job_status,
    request,
    people,
    description,
    subject,
    submission_deadline,
    msg_count,
    proposal_count,
    participation_ends,
    installation_start_date,
    installation_end_date,
    services,
    accept_status,
    thumbnail,
    due_date,
    cover_image,
    invoice_total,
    invoice_grand_total,
    design_order_total,
    partners,
    customer_pic,
    community_name,
    installationStatus,
    allInstallationCompleted,
    installation_acceptance,
   customer_name,
   awarded,
   paymentMode,
   quotation_status,
   quotation,
   estimate_job_status,
   statusRfp,
   syncWithQuickbooks,
   doc_number,
   est_doc_number,
  min_payment_status,
  project_category,
  job_category_name,
  installationCompleteStatus,
  billing_type,
  noServiceNoTask,
  proj_status,
  attachment_count,
  is_in_queue,
  send_client_app_req,
  attachment,
  isFromDesignOrder,
  duplicated_from,
  edited_by,
  isNewDesigns,
  isProject,
  isReview,
  avalara_code,
  old_design_order_name,
  partial_install,
  is_split_order,
  for_parent_facility,
  origin_facility_id,
  new_order,
  split_mirror_status,
  received_status,
  installation_pending_review,
  manager_approval_required,
  send_to_client,
  send_for_manager_approval,
  mixed_installation,
  rush,
  is_scheduled
} = card

  const groupedRequests = isGroupedInvoiceCard ? (card?.grouped_requests || []) : []
  const groupedSalesOrderNamesText = groupedRequests
    .map((row) => row?.name)
    .filter(Boolean)
    .join(', ') || 'Unknown Orders'
  const groupedInvoiceDisplayName = isGroupedInvoiceCard
  // This change ensures that the updated grouped invoice name is displayed on the card, preventing a mismatch between the card and the view page.
    //  ? `Combined Sales Orders - ${groupedSalesOrderNamesText}`
    ? (name && !String(name).startsWith('Combined Sales Orders')
        ? name
        : `Combined Sales Orders - ${groupedSalesOrderNamesText}`)
    : name
  const groupedJobNumbersText = isGroupedInvoiceCard
    ? getGroupedSalesOrderJobNumbersText(card, groupedRequests)
    : ''
  const groupedInvoiceNumbersText = isGroupedInvoiceCard
    ? getGroupedInvoiceDisplayNumbersText(card, groupedRequests)
    : ''
  const normalizeUnix = (value) => {
    const parsed = Number(value)
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null
  }
  const groupedDateCandidates = isGroupedInvoiceCard
    ? groupedRequests.flatMap((row) => {
      const installationStart = normalizeUnix(row?.installation_start_date)
      const installationEnd = normalizeUnix(row?.installation_end_date)
      const dueDate = normalizeUnix(row?.due_date)
      const participationEnds = normalizeUnix(row?.participation_ends)
      if (installationStart && installationEnd) return [installationStart, installationEnd]
      if (dueDate) return [dueDate]
      if (participationEnds) return [participationEnds]
      return [installationStart, installationEnd].filter(Boolean)
    })
    : []
  const groupedDateText = groupedDateCandidates.length > 0
    ? (() => {
      const minDate = Math.min(...groupedDateCandidates)
      const maxDate = Math.max(...groupedDateCandidates)
      if (minDate === maxDate) return moment.unix(minDate).format('MM/DD/YY')
      return `${moment.unix(minDate).format('MM/DD/YY')} - ${moment.unix(maxDate).format('MM/DD/YY')}`
    })()
    : ''
  const parseAmountNumber = (value) => {
    const parsed = Number(value)
    return Number.isFinite(parsed) ? parsed : 0
  }
  const getGroupedMemberInvoiceAmount = (row, parentRequestId = id) => {
    const isParentMember = Number(row?.id) === Number(parentRequestId)
    // Parent detail Total uses invoice_total; keep member/dialog amounts consistent.
    if (isParentMember && row?.invoice_total != null) {
      return parseAmountNumber(row.invoice_total)
    }
    if (row?.invoice_grand_total != null) {
      return parseAmountNumber(row.invoice_grand_total)
    }
    if (row?.invoice_total != null) {
      return parseAmountNumber(row.invoice_total)
    }
    return 0
  }
  // Pre-tax billable for a member (fallback only when parent has no stored total yet).
  const getGroupedMemberPreTaxAmount = (row) => {
    const rawTotal = row?.invoice_grand_total != null
      ? parseAmountNumber(row.invoice_grand_total)
      : parseAmountNumber(row?.invoice_total)
    const taxAmt = parseAmountNumber(row?.invoice_tax_amount)
    const addlAmt = parseAmountNumber(row?.invoice_addl_amount)
    return Math.max(0, rawTotal - taxAmt - addlAmt)
  }
  const groupedAmountValues = isGroupedInvoiceCard
    ? groupedRequests.map((row) => getGroupedMemberInvoiceAmount(row))
    : []
  const groupedHasAmount = groupedAmountValues.some((value) => value !== 0)
    || groupedRequests.some((row) => row?.invoice_grand_total != null || row?.invoice_total != null)
  const groupedCombinedTotal = groupedAmountValues.reduce((sum, value) => sum + value, 0)
  const groupedPreTaxCombinedTotal = isGroupedInvoiceCard
    ? groupedRequests.reduce((sum, row) => sum + getGroupedMemberPreTaxAmount(row), 0)
    : 0
  // Dedicated grouped parent (is_grouped_request=1) owns copied line items on its customer_order.
  // Detail page / preview Total uses customer_orders.total (invoice_total), including QB tax
  // after sync and any amount after edit/submit. Prefer that so the card stays in sync.
  const isTimeMaterialCard = Number(project_category || card?.project_category) === 12
  const parentGroupedInvoiceTotal = (() => {
    const totalAmt = invoice_total != null && invoice_total !== ''
      ? parseAmountNumber(invoice_total)
      : null
    const grandAmt = invoice_grand_total != null && invoice_grand_total !== ''
      ? parseAmountNumber(invoice_grand_total)
      : null

    if (isTimeMaterialCard) {
      if (grandAmt != null) return grandAmt
      if (totalAmt != null) return totalAmt
      if (groupedPreTaxCombinedTotal > 0) return groupedPreTaxCombinedTotal
      return null
    }

    // Always prefer parent stored total (updated on edit/submit and when QB tax is applied).
    // Do NOT keep using children pre-tax — that ignored parent edits and QB tax on the card.
    if (totalAmt != null) return totalAmt
    if (grandAmt != null) return grandAmt
    // Fallback only when parent has no customer_order total yet (e.g. mid-combine refresh)
    if (groupedRequests.length > 0 && groupedPreTaxCombinedTotal > 0) {
      return groupedPreTaxCombinedTotal
    }
    return null
  })()
  const resolvedDialogItemInvoiceAmount = isInvoiceGroupDialogItem
    ? getGroupedMemberInvoiceAmount(card, groupedParentRequestId)
    : null
  const effectiveInvoiceGrandTotal = isInvoiceGroupDialogItem
    ? resolvedDialogItemInvoiceAmount
    : isGroupedInvoiceCard
      ? (parentGroupedInvoiceTotal ?? (groupedHasAmount ? groupedCombinedTotal : invoice_grand_total))
      : invoice_grand_total
  const effectiveInvoiceTotal = isInvoiceGroupDialogItem
    ? resolvedDialogItemInvoiceAmount
    : isGroupedInvoiceCard
      ? (parentGroupedInvoiceTotal ?? (groupedHasAmount ? groupedCombinedTotal : invoice_total))
      : invoice_total
  const isGroupedInvoiceApproved = Number(card?.installation_acceptance || 0) === 1
  const invoiceSequenceSuffix = isInvoiceGroupDialogItem && invoiceSequenceIndex
    ? ` - ${invoiceSequenceIndex}`
    : ''
  const salesOrderStatusCard = isGroupedInvoiceCard && card?.grouped_requests?.[0]
    ? { ...card, ...card.grouped_requests[0] }
    : card
  const getSalesOrderStatusInfo = () => getStatusColorAndLabel(
    salesOrderStatusCard.status,
    salesOrderStatusCard.installationStatus,
    salesOrderStatusCard.allInstallationCompleted,
    salesOrderStatusCard.installation_acceptance,
    salesOrderStatusCard.min_payment_status,
    salesOrderStatusCard.billing_type,
    salesOrderStatusCard.noServiceNoTask ?? salesOrderStatusCard.proj_noServiceNoTask ?? noServiceNoTask,
    salesOrderStatusCard.proj_status,
    salesOrderStatusCard.job_category_name,
    salesOrderStatusCard.partial_install,
    salesOrderStatusCard.new_order,
    salesOrderStatusCard.for_parent_facility,
    salesOrderStatusCard.split_mirror_status,
    salesOrderStatusCard.received_status,
    salesOrderStatusCard.manager_approval_required,
    salesOrderStatusCard.send_to_client,
    salesOrderStatusCard.quotation_status,
    salesOrderStatusCard.is_scheduled,
  )
  const isGroupedInvoiceFullyApproved = () => {
    if (Number(card?.installation_acceptance) === 1) {
      return true
    }
    if (!groupedRequests.length) {
      return false
    }
    return groupedRequests.every((row) => Number(row?.installation_acceptance) === 1)
  }
  const getEffectiveSalesOrderStatusInfo = () => {
    if (!isGroupedInvoiceCard) {
      return getSalesOrderStatusInfo()
    }
    if (isGroupedInvoiceFullyApproved()) {
      return { color: 'success', label: 'Grouped Completed & Approved' }
    }
    if (currentTab === 'INVOICING') {
      return { color: 'warning', label: 'Grouped Completed & Waiting For Approval' }
    }
    if (currentTab === 'COMPLETED') {
      return { color: 'success', label: 'Grouped Completed & Approved' }
    }
    return getSalesOrderStatusInfo()
  }
  const hideInvoiceGroupCardMenu = isGroupedInvoiceCard || isInvoiceGroupDialogItem

console.log('proj_status proj_status',proj_status)

  const DESIGN_PREVIEW_EXTENSIONS = ['eps', 'ai', 'psd', 'tif', 'tiff', 'bmp', 'webp', 'ps', 'indd', 'indt', 'x-eps', 'x-ai', 'postscript']
  const getFileExtensionFromUrl = (url) => {
    if (!url) return ''
    const clean = url.split('?')[0]
    return clean.includes('.') ? clean.split('.').pop().toLowerCase() : ''
  }
  const isGoogleViewerDesign = (url, fileType = '', extension = '') => {
    const extFromUrl = getFileExtensionFromUrl(url)
    const ext = String(extension || '').toLowerCase()
    const ft = String(fileType || '').toLowerCase()
    const mimeSubtype = ft.includes('/') ? ft.split('/').pop() : ft
    return (
      DESIGN_PREVIEW_EXTENSIONS.includes(extFromUrl) ||
      DESIGN_PREVIEW_EXTENSIONS.includes(ext) ||
      DESIGN_PREVIEW_EXTENSIONS.includes(mimeSubtype)
    )
  }
  const filteredAttachments = designOrder
    ? attachment?.filter((imageItem) => imageItem?.isDesign == 1) || []
    : attachment || []
console.log('cardcardcardcard card',card)
 
  let customer_image = partners?.filter(
    (item) => item?.profile_pic != 'avatar.jpg',
  )
  let accepted_customer_image = partners
    ?.filter((item) => {
      item?.profile_pic != 'avatar.jpg' && item?.status == 1
    })
    ?.map((data) => {
      return data?.profile_pic
    })
  // console.log('customer_image--',customer_image);
  // console.log('accepted_customer_image--',accepted_customer_image);
  //  const currentUnix = moment().unix()
  //  console.log(currentUnix,'))))))))))))))))')
  //   console.log(submission_deadline,'$$$$$$$$$$$$$$$$')
  const updatedAt = moment.unix(timestamp).format('YYYY-MM-DD')
  //status color
  let CompletedStatus =
  mixed_installation == 1 ? 'Mixed Installations' :
    (installationCompleteStatus == 1 || split_mirror_status == 1)
      ? 'Installation'
      : (installationCompleteStatus == 2 || split_mirror_status == 2)
      ? received_status == 1 ? 'Picked Up' : 'Pick up'
      : CommunityJob 
      ? 'Installation' 
      : (installationCompleteStatus == 3 || split_mirror_status == 3)
      ? received_status == 1 ? 'Shipped' : 'Shipping'
      : ''
  const getStatusColorAndLabel = (  
    status,
    installationStatus,
    allInstallationCompleted,
    accepted,
    min_payment_status,
    billing_type,
    noServiceNoTask,
    proj_status,
    job_category_name,
    partial_install,
    new_order,
    for_parent_facility,
    split_mirror_status,
    received_status,
    manager_approval_required,
    send_to_client,
    quotation_status,
    is_scheduled
  ) => {
    // Sales orders no longer use manager approval — ignore DB flag for status labels
    // (old orders with manager_approval_required=1 must show normal Awaiting Approval).
    // Previous manager-approval label logic kept below for future re-enable.
    if ((new_order === 1 && [2, 3, 4].includes(status) && hold == 0)) {
      return { color: 'info', label: 'New' }
    }
    if(split_mirror_status == 7 && status == 3 && hold == 0){
      // return { color: 'warning', label: (manager_approval_required === true || manager_approval_required === 1) ? 'Awaiting Manager Approval' : 'Awaiting Approval' }
      return { color: 'warning', label: 'Awaiting Approval' }
    }
    switch (status) {
      case 1:
        return { color: 'warning', label: 'Draft' }
      case 2:
        // return { color:hold == 1 ? 'warning' : 'warning', label: hold == 1 ? 'Hold' : min_payment_status == 0 ? ((manager_approval_required === true || manager_approval_required === 1) ? 'Awaiting Manager Approval and Payment Due' : 'Awaiting Approval and Payment Due') : ((manager_approval_required === true || manager_approval_required === 1) ? 'Awaiting Manager Approval' : 'Awaiting Approval')}
        return { color:hold == 1 ? 'warning' : 'warning', label: hold == 1 ? 'Hold' : min_payment_status == 0 ? 'Awaiting Approval and Payment Due' : 'Awaiting Approval'}
      case 3:
        // if ((manager_approval_required === true || manager_approval_required === 1) && send_to_client == 0) {
        //   return { color: 'warning', label: 'Awaiting Manager Approval' };
        // }
        return {
          color: `${
            hold === 1 ? 'warning':
            project_category == 13
              ? 'primary'
              : min_payment_status == 0
              ? 'warning'
              : 'primary'
          }`,
          label: `${
            hold === 1 ? 'Hold' :
            project_category == 13 || billing_type == 0
              ? 'Approved'
              : min_payment_status == 1
              ? 'Approved'
              : 'Approved and Payment Due'
          }`,
        }
      // return { color: `${min_payment_status==0? 'warning' :'primary'}`, label: `${min_payment_status==1? 'Approved and Paid' :'Approved & Awaiting for Payment'}` }
      case 4:
        // return { color: 'success', label: !empty(allInstallationCompleted) ? 'Completed' : (!empty(installationStatus) ? 'Installation' : 'In Production') }
        // Only show "Installation In Review" when installation_pending_review is explicitly 1 (Installation tab); avoid showing when 0/null
        const isInstallationPendingReview = Number(installation_pending_review) === 1 && !empty(allInstallationCompleted) && empty(installation_acceptance)
        const isInstallationCompletedAndNotPublished = Number(installation_pending_review) === 2 && !empty(allInstallationCompleted) && empty(installation_acceptance)
        return {
          color: hold==1 ? 'warning' : (noServiceNoTask == 1 && proj_status == 3) ? 'success' :
            isInstallationCompletedAndNotPublished ? 'success' :
            (isReview == 2 && (!empty(allInstallationCompleted))) || isInstallationPendingReview ? 'warning' :
            split_mirror_status == 8 ? 'success' :
            min_payment_status == 0 ? 'warning' :
            empty(accepted) && (!empty(allInstallationCompleted && split_mirror_status !==1  && split_mirror_status !==2 && split_mirror_status !==3 && split_mirror_status !==5 && received_status !== 1) || split_mirror_status == 4)
              ? 'warning'
              : 'success',
          label: hold==1 ? 'Hold' : (noServiceNoTask == 1 && proj_status == 3 && project_category !== 12) ? 'No Service No Task' :
          (isReview == 2 && (!empty(allInstallationCompleted))) ? 'Completed & Awaiting Review' : isInstallationCompletedAndNotPublished ? 'Installation' : isInstallationPendingReview ? "Installation In Review" :
            split_mirror_status == 8 ? 'Production' :
            empty(accepted) && ((!empty(allInstallationCompleted && split_mirror_status !==1  && split_mirror_status !==2 && split_mirror_status !==3 && split_mirror_status !==5 && received_status !== 1) || split_mirror_status == 4))
              ? allInstallationCompleted ? `${CompletedStatus} Completed & Awaiting approval` : received_status == 1 ? `${CompletedStatus}` : `Completed & Awaiting approval`
              : (job_category_name === 'Build Order' && status === 4 && accepted === 1) ? 'Completed'
              : ((!empty(accepted) && (!empty(allInstallationCompleted))) || split_mirror_status == 5)
              ? allInstallationCompleted ? `${CompletedStatus} Completed & Approved` : `Completed & Approved`
              : !empty(installationStatus)
              ? partial_install == 1 ? 'Partially Installed':(proj_status != 3 && is_scheduled == 1) ? 'Production' :(proj_status != 3 && installationStatus) ? 'Partial Install' :(proj_status !=3) ? `Production` : min_payment_status == 0 ? `Payment Due for ${CompletedStatus}` : `${CompletedStatus}`
              : CommunityJob ? `${CompletedStatus} Completed & Approved` :
              (for_parent_facility == 2 && (split_mirror_status !== 0 && split_mirror_status !== 6)) ? (min_payment_status == 0 ? `Payment Due for ${CompletedStatus}` : `${CompletedStatus}`) : `Production`,
        } // return { color: 'primary', label: 'Converted to Job' };
      case 5:
        return { color: 'warning', label: 'Closed' }
      case 6:
        // if ((manager_approval_required === true || manager_approval_required === 1) && (send_to_client == 0 || quotation_status == 2)) {
        //   return { color: 'error', label: 'Rejected by Manager' };
        // }
        return { color: 'error', label: 'Rejected' }
         case 10:
        return { color: 'error', label: 'Void' }
      default:
        return { color: 'default', label: 'Open' }
    }
  }
  const getStatusColorAndLabelQuickbid = (status, quotation, estimate_job_status, hold, manager_approval_required, send_client_app_req, send_to_client, send_for_manager_approval, is_request_estimate) => {
    if (Number(status) === 12) {
      return { color: 'error', label: 'Void' };
    }
    if(hold == 1){
      return { color: 'warning', label: 'Hold' }; 
    }
    const sentToClient = send_client_app_req == 1 || send_to_client == 1;
    const isRequestEstimate = is_request_estimate == 1;
    const estimateJobComplete = Number(estimate_job_status) === 3;
    const resolvedStatus = Number(status);
    const isRejectedEstimate = resolvedStatus === 6 || resolvedStatus === 11;
    const managerReviewPending =
      !isRejectedEstimate &&
      (manager_approval_required === 1 || manager_approval_required === true) &&
      (send_for_manager_approval === 1 || send_for_manager_approval === true) &&
      !sentToClient;
    const isEstimateReview =
      !isRejectedEstimate &&
      status !== 1 &&
      (!isRequestEstimate || estimateJobComplete) &&
      managerReviewPending;
    if (isEstimateReview) {
      return { color: 'info', label: 'Review/ Send for Approval' };
    }
    switch (status) {
      case 1:
        return { color: 'warning', label: 'Draft' }
      case 2:
        return { color: 'info', label: sentToClient ? 'Awaiting Approval' : 'New' }
      case 3:
        if (isRequestEstimate) {
          return {
            color: estimate_job_status == 3 ? 'info' : estimate_job_status == 2 ? 'info': 'primary',
            label: estimate_job_status == 3 ? 'Review/ Send for Approval' : estimate_job_status == 2 ? 'In Progress': 'In Queue'
          };
        }
        // return {
        //   color: managerReviewPending ? 'info' : estimate_job_status == 2 ? 'info' : 'primary',
        //   label: managerReviewPending
        //     ? 'Review/ Send for Approval'
        //     : estimate_job_status == 2
        //     ? 'In Progress'
        //     : 'In Queue',
        // };
        return {
          color: 'info',
          label: managerReviewPending
            ? 'Review/ Send for Approval'
            : estimate_job_status == 2
            ? 'In Progress'
            : 'Review/ Send for Approval',
        };
      case 4:
        return {
          color: quotation == 0 ? 'default' : 'success',
          label: quotation == 0 ? 'Archive' : 'Approved',
        }
      case 5:
        return { color: 'warning', label: 'Closed' }
      case 6:
        return { color: 'error', label: 'Rejected' }
      case 9:
        if (isRequestEstimate) {
          return {
            color:
              Number(estimate_job_status) !== 3
                ? estimate_job_status == 2
                  ? 'info'
                  : 'primary'
                : 'info',
            label:
              Number(estimate_job_status) !== 3
                ? estimate_job_status == 2
                  ? 'In Progress'
                  : 'In Queue'
                : (manager_approval_required === true || manager_approval_required === 1) &&
                    (send_for_manager_approval === true || send_for_manager_approval === 1) &&
                    !sentToClient
                  ? 'Review/ Send for Approval'
                  : sentToClient
                  ? 'Awaiting Approval'
                  : (manager_approval_required === true || manager_approval_required === 1)
                  ? 'Awaiting Manager Approval'
                  : 'Awaiting Approval',
          };
        }
        return {
          color: 'info',
          label:
            (manager_approval_required === true || manager_approval_required === 1) &&
            (send_for_manager_approval === true || send_for_manager_approval === 1) &&
            !sentToClient
              ? 'Review/ Send for Approval'
              : sentToClient
              ? 'Awaiting Approval'
              : (manager_approval_required === true || manager_approval_required === 1)
              ? 'Awaiting Manager Approval'
              : 'Awaiting Approval',
        };
      case 10:
        if (isRequestEstimate) {
          return {
            color: estimate_job_status == 3 ? 'info' : estimate_job_status == 2 ? 'info' : 'primary',
            label:
              estimate_job_status == 3
                ? 'Review/ Send for Approval'
                : estimate_job_status == 2
                ? 'In Progress'
                : 'In Queue',
          };
        }
        return { color: 'info', label: 'Review/ Send for Approval' };
      case 11:
        return { color: 'error', label: 'Rejected by Manager' };
      case 12:
        return { color: 'error', label: 'Void' };
      default:
        return { color: 'default', label: 'Open' }
    }
  }
  const getStatusColorAndLabelDesignOrder = (status, hold, design_order_job_status, send_client_app_req, attachment_count, attachment, is_from_client, is_in_queue, send_to_client) => {
    // HOLD: hold=1 AND status !=0
    if (hold == 1 && status != 0) {
      return {
        color: 'warning',
        label: 'Hold',
      }
    }
    
    // // AWAITING APPROVAL: status 2 with sent to client (after manager approve / sent to client)
    // if (status == 2 && hold == 0 && (send_client_app_req == 1 || send_to_client == 1)) {
    //   return {
    //     color: 'info',
    //     label: 'Awaiting Approval',
    //   }
    // }
    
    // REJECTED: status=6 AND hold=0
    if (status == 6 && hold == 0) {
      return {
        color: 'error',
        label: 'Rejected',
      }
    }
    
    // APPROVED: status=2 AND hold=0
    if (status == 2 && hold == 0) {
      return {
        color: 'success',
        label: 'Approved',
      }
    }
    
    // DESIGN JOB COMPLETED: design_order_job_status = 3 AND send_client_app_req=0 AND status !=0 AND hold = 0
    // This should be checked before status 1 conditions
    if (design_order_job_status == 3 && send_client_app_req == 0 && status != 0 && hold == 0) {
      return {
        color: 'success',
        label: 'Review/Send for Approval',
      }
    }

    // Same as ViewDesignOrderDetails (array length, no isDesign filter)
    const hasDesignAttachments = attachment && Array.isArray(attachment) && attachment.length > 0;
    
    // For status 1, check conditions in priority order
    if (status == 1 && hold == 0) {
      // AWAITING APPROVAL: status=1 AND hold=0 AND send_client_app_req=1
      // Card payload clears attachment for status != 2, so don't require hasDesignAttachments here
      if (send_client_app_req == 1) {
        return {
          color: 'warning',
          label: 'Awaiting Approval',
        }
      }
      
      // IN DESIGN: doa.id IS NOT NULL AND status = 1 AND hold = 0 AND send_client_app_req=0 AND design_order_job_status != 3
      // if (send_client_app_req == 0 && design_order_job_status != 3 && hasDesignAttachments) {
      if (send_client_app_req == 0 && design_order_job_status == 2) {
        return {
          color: 'info',
          label: 'In Design',
        }
      }
      
      // NEW: status=1 AND hold=0 AND doa.id IS NULL AND design_order_job_status != 3 AND send_client_app_req=0
      // if (!hasDesignAttachments && design_order_job_status != 3 && send_client_app_req == 0) {
      if (send_client_app_req == 0 && (design_order_job_status == 1 || design_order_job_status == 7)  && is_in_queue == 1) {
        return {
          color: 'info',
          label: 'In Queue',
        }
      }
      if (send_client_app_req == 0 && design_order_job_status == 1 && is_in_queue == 0) {
        return {
          color: 'info',
          label: 'New',
        }
      }
      
      // Default fallback for status 1
      return {
        color: 'info',
        label: 'Open',
      }
    }
    
    // Other status cases
    switch (status) {
      case 3:
        return {
          color: hold == 1 ? 'warning' : 'success',
          label: hold == 1 ? 'Hold' : 'Approved',
        }
      case 4:
        return {
          color: hold == 1 ? 'warning' : 'warning',
          label: hold == 1 ? 'Hold' : 'Draft',
        }
      case 5:
        return {
          color: hold == 1 ? 'warning' : 'warning',
          label: hold == 1 ? 'Hold' : 'Closed',
        }
      default:
        return {
          color: hold == 1 ? 'warning' : 'default',
          label: hold == 1 ? 'Hold' : 'Open',
        }
    }
  }
  const getStatusColorAndLabelForProposal = (status) => {
    switch (status) {
      case 1:
        return { color: 'info', label: 'Open' }
      case 2:
        return { color: 'warning', label: 'Awarded' }
      case 3:
        return { color: 'error', label: 'Rejected' }
      case 4:
        return { color: 'success', label: 'Approved' }
      case 5:
        return { color: 'warning', label: 'Closed' }
      case 6:
        return { color: 'error', label: 'Rejected' }
      case 7:
        return { color: 'success', label: 'Paid' }
      default:
        return { color: 'info', label: 'Open' }
    }
  }

  const handleUpdateHoldStatus = async (reason) => {
    try {
      const user = JSON.parse(window.localStorage.getItem('user'));
      const res = await axios.post(
        `${REST_API_END_POINT}project/update-design-order-job-hold-status`,
        {
          projectId: Number(id),
          userId: user.user_id,
          reason: reason || '',
          designOrder: true,
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message, { variant: 'success' });
        setRenderCards(!renderCards);
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' });
      }
    } catch (error) {
      console.error('Error updating hold status:', error);
    }
  };

  const handleUpdateSalesOrderHoldStatus = async (reason) => {
    try {
      const user = JSON.parse(window.localStorage.getItem('user'));
      const res = await axios.post(
        `${REST_API_END_POINT}sales_order/update-sales-order-hold-status`,
        {
          request_id: Number(id),
          userId: user.user_id,
          reason: reason || '',
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message, { variant: 'success' });
        setRenderCards(!renderCards);
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' });
      }
    } catch (error) {
      console.error('Error updating hold status:', error);
    }
  };

  const handleVoidSalesOrder = async () => {
    if (!voidReason.trim()) {
      setVoidReasonError('Reason is required to void this sales order');
      return;
    }

    try {
      setLoadingVoid(true);
      const user = JSON.parse(window.localStorage.getItem('user'));
      const res = await axios.post(
        `${REST_API_END_POINT}sales_order/void-sales-order`,
        {
          request_id: Number(id),
          userId: user.user_id,
          reason: voidReason.trim(),
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message || 'Sales order voided successfully', { variant: 'success' });
        setOpenVoidPopup(false);
        setVoidReason('');
        setVoidReasonError('');
        setRenderCards(!renderCards);
      } else {
        enqueueSnackbar(res.data.message || 'Failed to void sales order', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error voiding sales order:', error);
      enqueueSnackbar('Failed to void sales order', { variant: 'error' });
    } finally {
      setLoadingVoid(false);
    }
  };

  const handleVoidEstimate = async () => {
    if (!voidReason.trim()) {
      setVoidReasonError('Reason is required to void this estimate');
      return;
    }

    try {
      setLoadingVoid(true);
      const res = await axios.post(
        `${REST_API_END_POINT}quotation/void-estimate`,
        {
          request_id: Number(id),
          userId,
          reason: voidReason.trim(),
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message || 'Estimate voided successfully', { variant: 'success' });
        setOpenVoidPopup(false);
        setVoidReason('');
        setVoidReasonError('');
        setRenderCards(!renderCards);
      } else {
        enqueueSnackbar(res.data.message || 'Failed to void estimate', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error voiding estimate:', error);
      enqueueSnackbar('Failed to void estimate', { variant: 'error' });
    } finally {
      setLoadingVoid(false);
    }
  };

  const reopenVoidSalesOrder = async (requestId) => {
    const user = JSON.parse(window.localStorage.getItem('user'));
    const res = await axios.post(
      `${REST_API_END_POINT}sales_order/reopen-void-sales-order`,
      {
        request_id: Number(requestId),
        userId: user.user_id,
      },
      {
        headers: { 'Content-Type': 'application/json' },
      }
    );
    return res.data;
  };

  const handleReopenVoidSalesOrder = async () => {
    try {
      setLoadingReopenVoid(true);
      const data = await reopenVoidSalesOrder(id);

      if (data.status === 1) {
        enqueueSnackbar(data.message || 'Sales order reopened successfully', { variant: 'success' });
        setOpenReopenVoidPopup(false);
        setRenderCards(!renderCards);
      } else {
        enqueueSnackbar(data.message || 'Failed to reopen sales order', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error reopening void sales order:', error);
      enqueueSnackbar('Failed to reopen sales order', { variant: 'error' });
    } finally {
      setLoadingReopenVoid(false);
    }
  };

  const reopenVoidEstimate = async (requestId) => {
    const res = await axios.post(
      `${REST_API_END_POINT}quotation/reopen-void-estimate`,
      {
        request_id: Number(requestId),
        userId,
      },
      {
        headers: { 'Content-Type': 'application/json' },
      }
    );
    return res.data;
  };

  const handleReopenVoidEstimate = async () => {
    try {
      setLoadingReopenVoid(true);
      const data = await reopenVoidEstimate(id);

      if (data.status === 1) {
        enqueueSnackbar(data.message || 'Estimate reopened successfully', { variant: 'success' });
        setOpenReopenVoidPopup(false);
        setRenderCards(!renderCards);
      } else {
        enqueueSnackbar(data.message || 'Failed to reopen estimate', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error reopening void estimate:', error);
      enqueueSnackbar('Failed to reopen estimate', { variant: 'error' });
    } finally {
      setLoadingReopenVoid(false);
    }
  };

  const option = [
    { id: 0, value: 'Inactive' },
    { id: 1, value: 'New' },
    { id: 2, value: 'Open' },
    { id: 3, value: 'Completed' },
    { id: 4, value: 'Hold' },
    { id: 5, value: 'Approved' },
    { id: 6, value: 'Rejected' },
    { id: 7, value: 'Verified' },
    { id: 6, value: 'Reopen' },
  ]
  const colors = [
    'error',
    'primary',
    'secondary',
    'success',
    'warning',
    'success',
    'error',
    'success',
    'error',
  ]

  // const handleOpenViewEstimate = (id,name) =>{
  //   setIsEditEstimate(true)
  //   setEstimateId(id)
  //   setEstimateName(name)
  //   setHandleOpenEstimate(true)
  //   console.log('hjsfgdhjdhbfhhhh')
  //   localStorage.setItem('estimateProjectId', id);
  //   localStorage.setItem('estimateProjectName', name);
  //   localStorage.setItem('isEditEstimate', "true");
  //   localStorage.setItem('estimateOpenProductionPopup', 'true');

  // }
  // const handleOpenDetails= (id,name) =>{
  //   setIsEditEstimate(false)
  //   setEstimateId(id)
  //   setEstimateName(name)
  //   setHandleOpenEstimate(true)
  //   localStorage.setItem('estimateProjectId', id);
  //   localStorage.setItem('estimateProjectName', name);
  //   localStorage.setItem('isEditEstimate', "false");
  //   localStorage.setItem('estimateOpenProductionPopup', 'true');
  // }
  // const handleOpenViewSalesOrder = (id,name) =>{
  //   setIsEditSalesOrder(true)
  //   setSalesOrderId(id)
  //   setSalesOrderName(name)
  //   setOpenSalesOrder(true)
  //   localStorage.setItem('salesOrderProjectId', id);
  //   localStorage.setItem('salesOrderProjectName', name);
  //   localStorage.setItem('isEditSalesOrder', "true");
  //   localStorage.setItem('salesOrderOpenPopup', 'true');

  // }
  // const handleOpenDetailsSalesOrder= (id,name) =>{
  //   setIsEditSalesOrder(false)
  //   setSalesOrderId(id)
  //   setSalesOrderName(name)
  //   setOpenSalesOrder(true)
  //   localStorage.setItem('salesOrderProjectId', id);
  //   localStorage.setItem('salesOrderProjectName', name);
  //   localStorage.setItem('isEditSalesOrder', "false");
  //   localStorage.setItem('salesOrderOpenPopup', 'true');
  // }
  // const handleOpenViewPurchaseOrder = (id, name) => {
  //   setIsEditPurchaseOrder(true)
  //   setPurchaseOrderId(id)
  //   setPurchaseOrderName(name)
  //   setOpenPurchaseOrder(true)
  //   localStorage.setItem('purchaseOrderProjectId', id)
  //   localStorage.setItem('purchaseOrderProjectName', name)
  //   localStorage.setItem('isEditPurchaseOrder', 'true')
  //   localStorage.setItem('purchaseOrderOpenPopup', 'true')
  // }
  // const handleOpenDetailsPurchaseOrder = (id, name) => {
  //   setIsEditPurchaseOrder(false)
  //   setPurchaseOrderId(id)
  //   setPurchaseOrderName(name)
  //   setOpenPurchaseOrder(true)
  //   localStorage.setItem('purchaseOrderProjectId', id)
  //   localStorage.setItem('purchaseOrderProjectName', name)
  //   localStorage.setItem('isEditPurchaseOrder', 'false')
  //   localStorage.setItem('purchaseOrderOpenPopup', 'true')
  // }
  const groupedCardBorder =
    theme.palette.mode === 'light'
      ? `2px solid ${theme.palette.grey[400]}`
      : `2px solid ${theme.palette.grey[600]}`

  const groupedStackWrapperSx = isGroupedInvoiceCard
    ? {
        height: '100%',
        ml: 2,
        position: 'relative',
        isolation: 'isolate',
        '&::before': {
          content: "''",
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1,
          borderRadius: 2,
          backgroundColor: theme.palette.background.paper,
          border: groupedCardBorder,
          boxShadow: theme.shadows[4],
          opacity: 0.95,
          pointerEvents: 'none',
          transform: 'translate(-6px, -8px) rotate(-2.5deg)',
        },
        '&::after': {
          content: "''",
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 2,
          borderRadius: 2,
          backgroundColor: theme.palette.background.paper,
          border: groupedCardBorder,
          boxShadow: theme.shadows[5],
          opacity: 0.98,
          pointerEvents: 'none',
          transform: 'translate(6px, -4px) rotate(2deg)',
        },
      }
    : { display: 'contents' }

  const groupedInnerCardSx = isGroupedInvoiceCard
    ? {
        overflow: 'hidden',
        borderRadius: 2,
        backgroundColor: theme.palette.background.paper,
        border: groupedCardBorder,
        boxShadow: theme.shadows[10],
        transition: 'transform 0.2s, box-shadow 0.2s',
        position: 'relative',
        zIndex: 3,
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: theme.shadows[12],
        },
      }
    : {}

  const isVoidEstimate = quotationView && Number(quotation) !== 0 && Number(quotation_status) === 12
  const isVoidOrder = Number(status) === 10
  const showVoidMutedStyle = isVoidOrder || isVoidEstimate

  const originFacility = FacilityTypes?.find((facility) => facility.id === origin_facility_id);
  const originFacilityColor = originFacility?.color && theme.palette[originFacility.color]?.main
    ? theme.palette[originFacility.color].main
    : theme.palette.grey[500];

  return (
    <>
    <Box sx={groupedStackWrapperSx}>
    <Card
    sx={{ 
      ml: isGroupedInvoiceCard ? 0 : 2,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      opacity: quotationView && quotation_status === 4 && quotation === 0 ? '75%':'100%',

      ...(showVoidMutedStyle && {
        position: 'relative',
        backgroundColor: theme.palette.mode === 'light'
          ? alpha(theme.palette.grey[500], 0.14)
          : alpha(theme.palette.grey[600], 0.28),
        filter: 'grayscale(75%)',
        opacity: 0.68,
        transition: 'all 0.3s ease-in-out',
        '& > *': {
          opacity: 0.8,
        },
        '&::after': {
          content: '"VOID"',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%) rotate(-10deg)',
          color: theme.palette.error.main,
          fontWeight: 800,
          fontSize: '20px',
          letterSpacing: '2px',
          zIndex: 10,
          opacity: 0.4,
          pointerEvents: 'none',
        },
        '&:hover': {
          filter: 'grayscale(45%)',
          opacity: 0.82,
          '& > *': {
            opacity: 0.95,
          },
          '&::after': {
            opacity: 0.2,
          },
        },
      }),

      ...((for_parent_facility === 2 || for_parent_facility === 1) && !isVoidOrder && {
        backgroundColor: 'black', // Black background
        color: 'white', // Text color for contrast
        position: 'relative', // Position to allow for the title overlay
        opacity: 0.8, // Darken the content of the card (without affecting the text)
        transition: 'all 0.3s ease-in-out', // Smooth transition for hover effect
    
        // Darken the card content (opacity for all child elements except the label)
        '& > *': {
          opacity: 0.5, // Reduce opacity of all child elements
        },
    
        // Add a label at the top, centered with higher z-index
        '&::before': {
          content: JSON.stringify(`From ${FacilityTypes?.find(facility => facility.id === origin_facility_id)?.label || customer_name || 'Unknown Facility'}`),        
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)', // Center the text both vertically and horizontally
          // color: 'white', // Text color
          // color : `${FacilityTypes.find(facility => facility.id === origin_facility_id)?.color ? 
          //   theme.palette[FacilityTypes.find(facility => facility.id === origin_facility_id).color].main : 
          //   theme.palette.grey[500]}`,
          color: originFacilityColor,
          padding: '10px 20px', // Padding around the text
          fontWeight: 'bold', // Bold text for emphasis
          fontSize: '16px',
          zIndex: 10, // Ensure the label is above other content
        },
    
        // On hover, revert to normal state and remove the label background
        '&:hover': {
          backgroundColor: 'inherit', // Revert to normal background
          color: 'inherit', // Text color returns to normal
          opacity: 1, // Return opacity to normal
          '& > *': {
            opacity: 1, // Remove opacity from child elements
          },
          // Keep the label on top during hover, but make the label disappear
          '&::before': {
            opacity: 0, // Make the "Build Order" label disappear on hover
          }
        },
      }),
      ...(is_split_order && {
        // border: `1px solid ${FacilityTypes.find(facility => facility.id === origin_facility_id)?.color ? 
        //   theme.palette[FacilityTypes.find(facility => facility.id === origin_facility_id).color].main : 
        //   theme.palette.grey[500]}`
        border: `1px solid ${originFacilityColor}`,
      }),
      ...(is_split_order && {
        // boxShadow: `0 -2px 8px ${FacilityTypes.find(facility => facility.id === origin_facility_id)?.color ?  
        //   theme.palette[FacilityTypes.find(facility => facility.id === origin_facility_id).color].main : 
        //   theme.palette.grey[500]}40, 0 4px 12px ${FacilityTypes.find(facility => facility.id === origin_facility_id)?.color ? 
        //   theme.palette[FacilityTypes.find(facility => facility.id === origin_facility_id).color].main : 
        //   theme.palette.grey[500]}30, 0 2px 6px ${FacilityTypes.find(facility => facility.id === origin_facility_id).color ? 
        //   theme.palette[FacilityTypes.find(facility => facility.id === origin_facility_id).color].main : 
        //   theme.palette.grey[500]}20`
        boxShadow: `0 -2px 8px ${originFacilityColor}40, 0 4px 12px ${originFacilityColor}30, 0 2px 6px ${originFacilityColor}20`,
      }),
      ...(isSalesOrder && salesOrderNewCard && getSalesOrderNewCardSx(theme, true)),
        cursor: 'pointer',
        position: 'relative',
        ...groupedInnerCardSx,
        //  backgroundColor: for_parent_facility === 2 ? 'inherit' : theme.palette.background.paper ,
      }}
      // sx={{ ml: 2 , opacity: quotationView && quotation_status === 4 && quotation === 0 ? '75%':'100%'}}
      id={id}
      onClick={
        isGroupedInvoiceCard && onGroupedCardClick ? handleGroupedCardClick :
        openHoldPopup ? undefined :
        CommunityProjects
          ? explodedPermissions?.some((permission) =>
              ['Add Jobs', 'Edit Jobs', 'Activate/Deactivate Jobs', 'Delete Jobs', 'Manage Job Cost'].includes(permission)
            ) || userType == 3
            ? () => navigate(PATH_DASHBOARD.project.viewproject + id)
            : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
          : quotationView
          // ? quotation_status != 6
            // Removed: ((quotation_status === 4 && quotation === 0) || userType === 3) condition
            // Removed: else branch that called handleOpenViewEstimate(id, name) - now always goes to details page
            // ? ((quotation_status === 3 || quotation_status === 4 || quotation_status === 9 || quotation === 0) || userType === 3)
            //   ? explodedPermissions?.some((permission) =>
            //       ['View Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
            //     ) || (userType === 3 && status !== 6)
            //     ? () => handleOpenDetails(id, name)
            //     : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
            //   : explodedPermissions?.some((permission) =>
            //       ['Edit Estimate'].includes(permission)
            //     ) || (userType === 3 && status !== 6)
            //     ? () => handleOpenViewEstimate(id, name)
            //     : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
            ? explodedPermissions?.some((permission) =>
                ['View Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
              ) || (userType === 3 && status !== 6)
              ? () => handleOpenDetails(id, name)
              : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
            // : () => enqueueSnackbar('Access Denied: Rejected Quotation', { variant: 'error' })
          : proposalView
          ? proposal_count === 0
            ? () => handleOpenViewPurchaseOrder(id, name)
            : () => enqueueSnackbar('Access Denied: Proposals Submitted', { variant: 'error' })
          : designOrder
          ? explodedPermissions?.some((permission) =>
              ['View Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
            ) || (userType === 3)
            ? () => handleOpenDetailsDesignOrder(id, name)
            : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
          : explodedPermissions?.some((permission) =>
              ['Create Request', 'Edit Request', 'Delete request', 'Add vendor to request', 'Add client to request'].includes(permission)
            ) || (userType === 3 && status !== 6)
          ? userType !== 3
            // ? empty(installationStatus)
            ? true
            ? () => CommunityJob ? navigate(`/dashboard/official-request/view/${id}`, { state: communityJobNavigateState }) :communityDesignOrder ? handleOpenDetailsDesignOrder(id, name) : handleOpenViewSalesOrder(id, name)
              : () => enqueueSnackbar('Access Denied: Moved to installation Phase', { variant: 'error' })
            : quotationView
            ? explodedPermissions?.some((permission) =>
                ['View Estimate', 'Create Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
              )
              ? () => handleOpenDetails(id, name)
              : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
            : designOrder
            ? explodedPermissions?.some((permission) =>
                ['View Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
              )
              ? () => handleOpenDetailsDesignOrder(id, name)
              : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
            : proposalView
            ? statusRfp === null || statusRfp === 1
              ? () => handleOpenViewPurchaseOrder(id, name)
              : () => enqueueSnackbar('Access Denied: Proposal submission closed', { variant: 'error' })
              : () => CommunityJob ? navigate(`/dashboard/official-request/view/${id}`, { state: communityJobNavigateState }) : communityDesignOrder ? handleOpenDetailsDesignOrder(id, name) : handleOpenDetailsSalesOrder(id, name)
          : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
      }
    >
      {isSalesOrder && salesOrderNewCard && (
        <SalesOrderNewBadge>NEW</SalesOrderNewBadge>
      )}
      {showSelectionCheckbox && (
        <Checkbox
          checked={selectionChecked}
          onClick={(event) => {
            event.stopPropagation()
            if (onSelectionChange) {
              onSelectionChange(card)
            }
          }}
          sx={{
            position: 'absolute',
            top: 36,
            left: 10,
            zIndex: 30,
            color: '#fff',
            backgroundColor: 'rgba(0, 0, 0, 0.45)',
            borderRadius: 1,
            p: 0.25,
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.65)',
            },
          }}
        />
      )}
      <CardMediaStyle>
        {/* <IconButton
        sx={{
          top: 8,zIndex:500,color:theme.palette.grey.A100,
          right: 5,
          position: 'absolute'
        }}
      >
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton> */}
          {/* <SvgIconStyle
          color="paper"
          src={image}
          sx={{
            width: 144,
            height: 62,
            zIndex: 10,
            bottom: -26,
            position: 'absolute'
          }}
        /> */}

          <AvatarGroup
            max={7}
            sx={{ '& .MuiAvatar-root': { width: 62, height: 62, zIndex: 10 } }}
          >
            {team_member?.length > 0 &&
              team_member?.map((person) => {
                return (
                  <Tooltip title={person?.member_name}>
                    <Avatar
                      key={person.id}
                      sx={{
                        width: 30,
                        height: 30,
                        position: 'absolute',
                        transform: 'translateY(-50%)',
                      }}
                      alt={person?.member_name}
                      src={person?.profile_pic}
                    />
                  </Tooltip>
                )
              })}
          </AvatarGroup>
          {(() => {
            const firstAttachment = filteredAttachments?.[0]
            const imageUrl = firstAttachment?.name
              ? firstAttachment.name
              : customer_pic && customer_pic !== 'avatar.jpg'
              ? customer_pic
              : COMPANY_LOGO
            const isDesignPreview = isGoogleViewerDesign(
              imageUrl,
              firstAttachment?.file_type || '',
              firstAttachment?.extension || '',
            )
            if (isDesignPreview) {
              return (
                <Box
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: 8,
                  }}
                >
                  <iframe
                    src={`https://docs.google.com/gview?url=${encodeURIComponent(imageUrl)}&embedded=true&chrome=false`}
                    title={imageUrl}
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    style={{ border: 'none', pointerEvents: 'none' }}
                  />
                </Box>
              )
            }
            return (
              <CoverImgStyle
                alt="cover"
                src={imageUrl}
              />
            )
          })()}
          <Box
            sx={{
              position: 'absolute',
              top: 35,
              right: 10,
              zIndex: 20,
              borderRadius: '50%',
              backdropFilter: theme.palette.mode !== 'light' ?'blur(6px)': 'blur(12px)',
              backgroundColor: theme.palette.mode !== 'light' ?'rgba(0, 0, 0, 0.3)': 'rgba(255, 255, 255, 0.71)',
              boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
            }}>
                  {(user?.user_type !=3 && currentTab!="APPROVED" && designOrder) && (status === 1 || status === 6) && for_parent_facility !== 2 &&
                    <UserMoreMenu
                      hold={hold}
                      {...(currentTab!="APPROVED" && (status === 1 || status === 6) ? { onHold:()=>{
                        if(explodedPermissions?.some(permission => ['Hold Design Order Jobs'].includes(permission))){
                          setOpenHoldPopup(true);
                        }else{
                          enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' });
                        }
                      }} : {})}
          
                    />
                  }

                  {(user?.user_type !=3 && Number(allInstallationCompleted) !== 1 && isSalesOrder && status !== 10&& !hideInvoiceGroupCardMenu) && for_parent_facility !== 2 &&
                    <UserMoreMenu
                      hold={hold}
                      onHold={() => {
                        setOpenHoldPopup(true);
                      }}
                      onVoid={
                        explodedPermissions?.some(permission => ['Delete request'].includes(permission))
                          ? () => {
                              setVoidReason('');
                              setVoidReasonError('');
                              setOpenVoidPopup(true);
                            }
                          : undefined
                      }
                    />
                  }

                  {(user?.user_type !=3 && quotationView && Number(quotation) !== 0 && Number(quotation_status) !== 12 && for_parent_facility !== 2) &&
                    <UserMoreMenu
                      hold={hold}
                      onHold={() => {
                        setOpenHoldPopup(true);
                      }}
                      onVoid={
                        explodedPermissions?.some(permission => ['Delete Estimate'].includes(permission))
                          ? () => {
                              setVoidReason('');
                              setVoidReasonError('');
                              setOpenVoidPopup(true);
                            }
                          : undefined
                      }
                    />
                  }

                  {(user?.user_type !=3 && isSalesOrder && status === 10 && currentTab === 'VOID') && for_parent_facility !== 2 &&
                    <UserMoreMenu
                      onReopen={
                        explodedPermissions?.some(permission => ['Delete request'].includes(permission))
                          ? () => setOpenReopenVoidPopup(true)
                          : undefined
                      }
                    />
                  }

                  {(user?.user_type !=3 && quotationView && Number(quotation) !== 0 && Number(quotation_status) === 12 && currentTab === 'VOID') && for_parent_facility !== 2 &&
                    <UserMoreMenu
                      onReopen={
                        explodedPermissions?.some(permission => ['Delete Estimate'].includes(permission))
                          ? () => setOpenReopenVoidPopup(true)
                          : undefined
                      }
                    />
                  }

            <Dialog
              open={openHoldPopup}
              onClose={(event) => {
                event.stopPropagation();
                setOpenHoldPopup(false);
                setHoldReason('');
              }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              BackdropProps={{ invisible: true }}
            >
              <DialogTitle id="alert-dialog-title">
                {hold === 1 ? 'Remove from Hold?' : 'Move to Hold?'}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {
                    designOrder ? (
                      hold === 1
                        ? 'You want to move this Design Order from Hold.'
                        : 'You want to move this Design Order to Hold.'
                    ) : (
                      hold === 1
                        ? 'You want to move this Sales Order from Hold.'
                        : 'You want to move this Sales Order to Hold.'
                    )
                  }
                  {/* {hold === 1
                    ? 'You want to move this Design Order from Hold.'
                    : 'You want to move this Design Order to Hold.'} */}
                </DialogContentText>
                {(hold === 0)? (
                  <TextField
                    sx={{ width: 400 }}
                    label="Reason"
                    type="text"
                    multiline
                    minRows={3}
                    maxRows={7}
                    value={holdReason}
                    onChange={(e) => {
                      e.stopPropagation();
                      setHoldReason(e.target.value);
                      if (holdReasonError) setHoldReasonError('');
                    }}
                    error={Boolean(holdReasonError)}
                    helperText={holdReasonError}
                  />
                ) : ''}
              </DialogContent>
              <DialogActions>
                <Button
                  size="small"
                  variant="contained"
                  onClick={async (event) => {
                    event.stopPropagation();
                    if ((hold === 0 ) && !holdReason.trim()) {
                      setHoldReasonError(`Reason is required to put this ${designOrder ?'Design Order on Hold' : 'Sales Order on Hold' }.`);
                      return;
                    }

                    setIsSubmittingHold(true);
                    if(designOrder){
                      await handleUpdateHoldStatus(holdReason);
                    }else{
                      await handleUpdateSalesOrderHoldStatus(holdReason)
                    }
                    setIsSubmittingHold(false);
                    setOpenHoldPopup(false);
                    setHoldReason('');
                    setHoldReasonError('');
                  }}
                  disabled={isSubmittingHold}
                >
                  {isSubmittingHold ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    'OK'
                  )}
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={(event) => {
                    event.stopPropagation();
                    setOpenHoldPopup(false);
                    setHoldReason('');
                  }}
                  sx={{ color: theme.palette.error.main }}
                >
                  Cancel
                </Button>
              </DialogActions>
            </Dialog>

            </Box>
          <Stack sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography
              sx={{ position: 'absolute', top: 8, left: 10, zIndex: 10 }}
            >
              {CommunityProjects ? (
                <Label
                  variant="filled"
                  color={colors[status]}
                >
                  {option.find((opt) => opt.id === status).value}
                </Label>
              ) : (
                <Label
                  variant="filled"
                  color={
                    designOrder
                      ? getStatusColorAndLabelDesignOrder(status, hold, design_order_job_status, send_client_app_req, attachment_count, attachment, is_from_client, is_in_queue).color
                      : quotationView
                      ? getStatusColorAndLabelQuickbid(
                          quotation_status,
                          quotation,
                          estimate_job_status,
                          hold,
                          manager_approval_required,
                          send_client_app_req,
                          send_to_client,
                          send_for_manager_approval,
                          is_request_estimate
                        ).color
                      : proposalView
                      ? getStatusColorAndLabelForProposal(
                          userType != 3 ? (paymentMode ? 7 : awarded ? 2 : 1) : paymentMode ? 7 : statusRfp,
                        ).color
                      : getEffectiveSalesOrderStatusInfo().color
                  }
                >
                  <Tooltip
                    title={
                      designOrder
                        ? getStatusColorAndLabelDesignOrder(status, hold, design_order_job_status, send_client_app_req, attachment_count, attachment, is_from_client, is_in_queue, send_to_client).label
                        : quotationView
                        ? getStatusColorAndLabelQuickbid(
                            quotation_status,
                            quotation,
                            estimate_job_status,
                            hold,
                            manager_approval_required,
                            send_client_app_req,
                            send_to_client,
                            send_for_manager_approval,
                            is_request_estimate
                          ).label
                        : proposalView
                        ? getStatusColorAndLabelForProposal(
                            userType != 3 ? (paymentMode? 7:awarded ? 2 : 1) : paymentMode ? 7 : statusRfp,
                          ).label
                        : getEffectiveSalesOrderStatusInfo().label
                    }
                  >
                    <Typography
                      variant="caption"
                      sx={{
                        fontSize: '10px',
                        cursor: 'pointer',
                        display: 'inline-block',
                        minWidth:70,
                        maxWidth: 70,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        textAlign: 'center',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      <span
                        style={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {designOrder
                          ? getStatusColorAndLabelDesignOrder(status, hold, design_order_job_status, send_client_app_req, attachment_count, attachment, is_from_client, is_in_queue, send_to_client)
                              .label
                          : quotationView
                          ? getStatusColorAndLabelQuickbid(
                              quotation_status,
                              quotation,
                              estimate_job_status,
                              hold,
                              manager_approval_required,
                              send_client_app_req,
                              send_to_client,
                              send_for_manager_approval,
                              is_request_estimate
                            ).label
                          : proposalView
                          ? getStatusColorAndLabelForProposal(
                              userType != 3 ? (paymentMode? 7:awarded ? 2 : 1) : paymentMode ? 7 : statusRfp,
                            ).label
                          : getEffectiveSalesOrderStatusInfo().label}
                      </span>
                    </Typography>
                  </Tooltip>
                </Label>
              )}
            </Typography>
            {proposalView && isAdminUser (userType) && Number(proposal_count || 0) > 0 && (
              <Box sx={{ position: 'absolute', top: 8, right: 10, zIndex: 12, display: 'flex', gap: 0.75 }}>
                {!awarded && !paymentMode && (statusRfp == null || Number(statusRfp) === 1) && (
                  <Box onMouseDown={(event) => event.stopPropagation()}>
                    <AnimatedButton
                      size="small"
                      title="Award"
                    startIcon={<EmojiEvents sx={{ width: 14, height: 14 }} />}
                    onClick={(event) => {
                      event.stopPropagation()
                      if (awardActionLoadingId === (card?.proposal_id || id)) return
                      onProposalAwardAction?.(card, 'award')
                    }}
                  />
                  </Box>
                )}
                {awarded && !paymentMode && (statusRfp == null || Number(statusRfp) === 2) && (
                  <Box onMouseDown={(event) => event.stopPropagation()}>
                    <AnimatedButton
                      size="small"
                      title="Mark As Paid"
                    startIcon={<Payment sx={{ width: 14, height: 14 }} />}
                    onClick={(event) => {
                      event.stopPropagation()
                      if (awardActionLoadingId === (card?.proposal_id || id)) return
                      onProposalAwardAction?.(card, 'payment')
                    }}
                  />
                  </Box>
                )}
              </Box>
            )}

            {
              
             ( designOrder && isNewDesigns == 1) && (!send_client_app_req && userType !==3) ?(
    <Typography
                sx={{ position: 'absolute', bottom: 40, right: 10, zIndex: 10 }}
              >
                <Label
                  variant="filled"
                  color="success"
                >
                  <Tooltip title={"New Designs"}>
                    <Typography
                      variant="caption"
                      sx={{
                        fontSize: '10px',
                        cursor: 'pointer',
                        display: 'inline-block',
                        maxWidth: 120,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      <span
                        style={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        New Designs
                      </span>
                    </Typography>
                  </Tooltip>
                </Label>
              </Typography>
              ) : (((quotation != 0 || (quotation == 0 && quotation_status != 2)) && is_request_estimate && quotationView) ? (
              <Typography
                sx={{ position: 'absolute', bottom: 40, right: 10, zIndex: 10 }}
              >
                {/* <Label
                  variant="filled"
                  color="success"
                >
                  <Tooltip title={"Request Estimate"}>
                    <Typography
                      variant="caption"
                      sx={{
                        fontSize: '10px',
                        cursor: 'pointer',
                        display: 'inline-block',
                        maxWidth: 120,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      <span
                        style={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Request Estimate
                      </span>
                    </Typography>
                  </Tooltip>
                </Label> */}
              </Typography>
              ) : "")
            }

            {/* {!quotationView && !proposalView ?<Typography sx={{ position: 'absolute', top: 8, right: 10, zIndex: 10 }}> */}
            {!proposalView ? (
              <Typography
                sx={{ 
                  position: 'absolute', 
                  top: 8,
                  right: 10,
                  zIndex: 10,
                  maxWidth: (estimateNewCard || designOrderNewCard)
                    ? 'calc(100% - 150px)'
                    : 'calc(100% - 100px)',
                }}
              >
                {!CommunityProjects ? (
                  (quotation != 0 && is_request_estimate && !community_name) ? '' :
                  (community_name ? (
                    <Label
                      variant={
                        theme.palette.mode === 'light' ? 'filled' : 'filled'
                      }
                      color={'warning'}
                    >
                      <Tooltip title={community_name}>
                        <Typography
                          variant="caption"
                          sx={{
                            fontSize: '10px',
                            cursor: 'pointer',
                            display: 'inline-block',
                            maxWidth: (estimateNewCard || designOrderNewCard) ? 70 : 90,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          <span
                            style={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {community_name}
                          </span>
                        </Typography>
                      </Tooltip>
                    </Label>
                  ) : (
                    for_parent_facility === 1 || for_parent_facility === 2 ? (
                      ''
                    ) : (
                    <Label
                      variant=
                        "filled"
                      
                      color={'error'}
                    >
                      <Typography variant="caption" sx={{ fontSize: '10px' }}>
                        No project
                      </Typography>
                    </Label>
                  ))
                  )
                ) : (
                  ''
                )}
              </Typography>
            ) : (
              ''
            )}
            {!CommunityProjects && !proposalView && (customer_name || is_split_order && for_parent_facility == 1) ? (
              <Typography
                sx={{ 
                  position: 'absolute', 
                  bottom: 8, 
                  left: 10, 
                  zIndex: 10,
                  maxWidth: 'calc(50% - 20px)'
                }}
              >
                <Label
                  variant="filled"
                  color="secondary"
                >
                  <Tooltip title={
                    is_split_order && (for_parent_facility == 1  || for_parent_facility == 2)
                      ? FacilityTypes?.find(facility => facility.id === origin_facility_id)?.label || customer_name || ''
                      : customer_name || ''
                  }>
                    <Typography
                      variant="caption"
                      sx={{
                        fontSize: '10px',
                        cursor: 'pointer',
                        display: 'inline-block',
                        maxWidth: '120px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      <span
                        style={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {is_split_order && (for_parent_facility == 1  || for_parent_facility == 2)
                          ? FacilityTypes?.find(facility => facility.id === origin_facility_id)?.label || customer_name || ''
                          : customer_name || ''
                        }
                      </span>
                    </Typography>
                  </Tooltip>
                </Label>
              </Typography>
            ):''}
            {
              <Typography
                sx={{ 
                  position: 'absolute', 
                  bottom: 8, 
                  right: 10, 
                  zIndex: 10,
                  maxWidth: 'calc(50% - 20px)',
                  textAlign: 'right'
                }}
              >
                {!CommunityProjects ? (
                  ((isGroupedInvoiceCard && groupedDateText) || participation_ends || (installation_start_date && installation_end_date)) ? (
                    <Label
                      variant=
                        "filled"
                      
                      color={'default'}
                    >
                      <Tooltip
                        title={
                          quotationView || proposalView
                            ? 'Date Created'
                            : 'Installation Date'
                        }
                      >
                        <Typography
                          variant="caption"
                          sx={{
                            fontSize: '10px',
                            cursor: 'pointer',
                            display: 'inline-block',
                            maxWidth: '100%',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          <span
                            style={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {isGroupedInvoiceCard && groupedDateText ? (
                              groupedDateText
                            ) : installation_start_date && installation_end_date ? (
                              `${moment.unix(installation_start_date).format('MM/DD/YY')} - ${moment.unix(installation_end_date).format('MM/DD/YY')}`
                            ) : (
                              moment.unix(participation_ends).format('MM/DD/YY')
                            )}
                          </span>
                        </Typography>
                      </Tooltip>
                    </Label>
                  ) : (
                    ''
                  )
                ) : (
                  ''
                )}
                {designOrder ? (
                  due_date ? (
                    <Label
                      variant=
                        "filled"
                      
                      color={'default'}
                    >
                      <Tooltip title={'Installation Date'}>
                        <Typography
                          variant="caption"
                          sx={{
                            fontSize: '10px',
                            cursor: 'pointer',
                            display: 'inline-block',
                            maxWidth: '100%',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          <span
                            style={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {moment.unix(due_date).format('MM/DD/YY')}
                          </span>
                        </Typography>
                      </Tooltip>
                    </Label>
                  ) : (
                    ''
                  )
                ) : (
                  ''
                )}
              </Typography>
            }
          </Stack>
        </CardMediaStyle>
        <Box sx={{
          display: 'flex',
          visibility: isGroupedInvoiceCard ? 'hidden' : 'visible',
          justifyContent: 'space-between',
          alignItems:'center',
          padding: 0.5,
          minHeight: 32,
          flexShrink: 0,
          borderTop: `1px solid ${theme.palette.divider}`,
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {
              duplicated_from && !edited_by ?
            <Stack
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
              }}
            >
              <Label
                variant="filled"
                color="error"
              >
                <Tooltip title={'Duplicated'}>
                  <Typography
                    variant="caption"
                    sx={{
                      fontSize: '10px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems:'center',
                      maxWidth: 120,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    <Icon icon={copyFill} width={12} height={12} style={{ marginRight: 3 }} />
                    <span
                      style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      Duplicated
                    </span>
                  </Typography>
                </Tooltip>
              </Label>
            </Stack> : ''
            }
            {job_category_name ? (
              <Stack
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                }}
              >
                <Label
                  variant="filled"
                  color="info"
                >
                  <Tooltip title={job_category_name}>
                    <Typography
                      variant="caption"
                      sx={{
                        fontSize: '10px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        maxWidth: 130,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {job_category_name === 'Retail' && (
                        <ShoppingBag sx={{ fontSize: 12, mr: 0.5 }} />
                      )}
                      {job_category_name === 'Time & Material' && (
                        <AccessTime sx={{ fontSize: 12, mr: 0.5 }} />
                      )}
                      {job_category_name === 'No Charge' && (
                        <LocalOffer sx={{ fontSize: 12, mr: 0.5 }} />
                      )}
                      {job_category_name === 'Service only' && (
                        <CreditCard sx={{ fontSize: 12, mr: 0.5 }} />
                      )}
                      <span
                        style={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {job_category_name}
                      </span>
                    </Typography>
                  </Tooltip>
                </Label>
              </Stack>
            ) : (
              ''
            )}
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {(estimateNewCard || designOrderNewCard) && (
              <Box>
                <Label
                  variant="filled"
                >
                  <IconWrapperStyle>
                    <Icon width={14} height={14} icon={briefcaseFill} />
                  </IconWrapperStyle>
                  <Typography
                    variant="caption"
                    sx={{
                      fontSize: '10px',
                      cursor: 'pointer',
                      display: 'inline-block',
                      maxWidth: 40,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    <span
                      style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      New
                    </span>
                  </Typography>
                </Label>
              </Box>
            )}
            {rush && (
              <Box>
                <Label
                  variant="filled"
                    sx={{
                        backgroundColor: 'red',
                        color: 'white', // optional for contrast
                       }}
                 >
                  <Typography
                    variant="caption"
                    sx={{
                      fontSize: '10px',
                      cursor: 'pointer',
                      display: 'inline-block',
                      maxWidth: 50,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    <span
                      style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      Rush
                    </span>
                  </Typography>
                </Label>
              </Box>
            )}
            {designOrder && status == 1 && attachment_count > 0 && send_client_app_req == 1 && (
              <Box>
                <Label
                  variant="filled"
                  color="warning"
                >
                  <Tooltip title={(manager_approval_required === true || manager_approval_required === 1) ? 'Awaiting Manager Approval' : 'Awaiting Approval'}>
                    <Typography
                      variant="caption"
                      sx={{
                        fontSize: '10px',
                        cursor: 'pointer',
                        display: 'inline-block',
                        maxWidth: 120,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      <span
                        style={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {(manager_approval_required === true || manager_approval_required === 1) ? 'Awaiting Manager Approval' : 'Awaiting Approval'}
                      </span>
                    </Typography>
                  </Tooltip>
                </Label>
              </Box>
            )}
          </Box>
        </Box>

        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
        <Stack
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 1,
            mt: 0.5,
            mb: 0.5,
            px: 0.5,
            flexShrink: 0
          }}
        >
          <Tooltip title={preserveWhitespaceTitle(groupedInvoiceDisplayName)}>
            {/* <Typography
              onClick={
                CommunityProjects
                  ? explodedPermissions?.some((permission) => [ 'Add Jobs', 'Edit Jobs', 'Activate/Deactivate Jobs', 'Delete Jobs', 'Manage Job Cost', ].includes(permission), ) || userType == 3
                    ? () => navigate(PATH_DASHBOARD.project.viewproject + id)
                    : () => enqueueSnackbar( 'Access Denied: You do not have sufficient permissions', { variant: 'error' },)
                  : quotationView
                        ? quotation_status != 6
                          ? () => quotation_status === 4 && quotation === 0
                                ? (explodedPermissions?.some((permission) =>['View Estimate, Edit Estimate, Delete Estimate'].includes(permission)) || (userType === 3 && status !== 6))
                                  ? () => handleOpenDetails(id, name)
                                  : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                                : (explodedPermissions?.some((permission) =>['Edit Estimate'].includes(permission)) || (userType === 3 && status !== 6))
                                  ? () => handleOpenViewEstimate(id, name)
                                  : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                          : () => enqueueSnackbar( 'Access Denied: Rejected Quotation',{ variant: 'error' },)
                        : proposalView
                        ? proposal_count === 0
                          ? () => handleOpenViewPurchaseOrder(id, name)
                          : () => enqueueSnackbar( 'Access Denied: Proposals Submited', { variant: 'error' },)
                        : designOrder
                        ? (explodedPermissions?.some((permission) =>
                          ['View Design Order', 'Create Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                        ) || (userType === 3 && status !== 6))
                          ? () => handleOpenDetailsDesignOrder(id, name)
                          : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                      : explodedPermissions?.some((permission) =>
                        [
                          'Create Request',
                          'Edit Request',
                          'Delete request',
                          'Add vendor to request',
                          'Add client to request',
                        ].includes(permission),
                      ) ||
                      (userType === 3 && status !== 6)
                    ? userType !== 3
                    ? empty(installationStatus)
                      ? () =>
                            // navigate(`/dashboard/official-request/view/${id}`)
                            handleOpenViewSalesOrder(id, name)
                      : () => enqueueSnackbar( 'Access Denied: Moved to installation Phase',{ variant: 'error' },)
                    : quotationView
                    ? explodedPermissions?.some((permission) =>
                      ['View Estimate', 'Create Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
                    )
                      ? () => handleOpenDetails(id, name)
                      : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                    // ? () =>
                    //     // navigate(`/dashboard/quick-bid/view/${id}`)
                    //     handleOpenDetails(id, name)
                    : designOrder
                    ? explodedPermissions?.some((permission) =>
                      ['View Design Order', 'Create Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                    )
                      ? () => handleOpenDetailsDesignOrder(id, name)
                      : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                    : proposalView
                    ? statusRfp === null || statusRfp === 1
                      ? () => handleOpenViewPurchaseOrder(id, name)
                      : // navigate(`/dashboard/rfp/view/${id}`, { state: true })
                        () => enqueueSnackbar('Access Denied: Proposal submission closed',{ variant: 'error' },)
                    : () =>
                        // navigate(`/dashboard/official-request/view/${id}`)
                        handleOpenDetailsSalesOrder(id, name)
                  : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions',{ variant: 'error' },)
              }
              variant="subtitle1"
              sx={{
                mt: 2,
                ml: 2,
                maxWidth: userType != 3 && !CommunityProjects ? 150 : '70%',
                cursor: 'pointer',
                display: 'inline-block',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                color: theme.palette.primary.main,
                '&:hover': {
                  cursor: CommunityProjects
                    ? explodedPermissions?.some((permission) =>
                        [
                          'Add Jobs',
                          'Edit Jobs',
                          'Activate/Deactivate Jobs',
                          'Delete Jobs',
                          'Manage Job Cost',
                        ].includes(permission),
                      )
                      ? 'pointer'
                      : 'default'
                    : quotationView
                      ? explodedPermissions?.some((permission) =>
                        [ 'View Estimate', 'Create Estimate', 'Edit Estimate', 'Delete Estimate', ].includes(permission)
                      )
                      ? 'pointer'
                      : 'default'
                    : designOrder
                      ? explodedPermissions?.some((permission) =>
                        ['View Design Order', 'Create Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                      )
                      ? 'pointer'
                      : 'default'
                    : (explodedPermissions?.some((permission) =>
                        [
                          'Create Request',
                          'Edit Request',
                          'Delete request',
                          'Add vendor to request',
                          'Add client to request',
                        ].includes(permission),
                      ) ||
                        (userType === 3 && status !== 6)) &&
                      !(userType === 3 && accept_status === 2)
                    ? 'pointer'
                    : 'default',
                },
              }}
            >
              <span
                style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {groupedInvoiceDisplayName}
              </span>
            </Typography> */}
            <Typography
              onClick={
                isGroupedInvoiceCard
                  ? () => handleOpenDetailsSalesOrder?.(id, groupedInvoiceDisplayName, false, true)
                  :
                CommunityProjects
                  ? explodedPermissions?.some((permission) =>
                      ['Add Jobs', 'Edit Jobs', 'Activate/Deactivate Jobs', 'Delete Jobs', 'Manage Job Cost'].includes(permission)
                    ) || userType == 3
                    ? () => navigate(PATH_DASHBOARD.project.viewproject + id)
                    : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                  : quotationView
                  // ? quotation_status != 6
                    // Removed: ((quotation_status === 3 || quotation_status === 4 || quotation_status === 9 || quotation === 0) || userType === 3) condition
                    // Removed: else branch that called handleOpenViewEstimate(id, name) - now always goes to details page
                    ? explodedPermissions?.some((permission) =>
                        ['View Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
                      ) || (userType === 3 && status !== 6)
                      ? () => handleOpenDetails(id, name)
                      : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                    // : () => enqueueSnackbar('Access Denied: Rejected Quotation', { variant: 'error' })
                  : proposalView
                  ? proposal_count === 0
                    ? () => handleOpenViewPurchaseOrder(id, name)
                    : () => enqueueSnackbar('Access Denied: Proposals Submitted', { variant: 'error' })
                  : designOrder
                  ? explodedPermissions?.some((permission) =>
                      ['View Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                    // ) || (userType === 3 && status !== 6)
                    ) || (userType === 3 )
                    // ? () => navigate(`/dashboard/design-order/view/${id}`)
                    ? () => handleOpenDetailsDesignOrder(id, name)
                    : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                  : explodedPermissions?.some((permission) =>
                      ['Create Request', 'Edit Request', 'Delete request', 'Add vendor to request', 'Add client to request'].includes(permission)
                    ) || (userType === 3 && status !== 6)
                  ? userType !== 3
                    // ? empty(installationStatus)
                    ? true
                    // ? () => CommunityJob ? navigate(`/dashboard/official-request/view/${id}`, { state: { fromProjects: true } }) :communityDesignOrder ? navigate(`/dashboard/design-order/view/${id}`) : handleOpenViewSalesOrder(id, name)  
                    ? () => CommunityJob ? navigate(`/dashboard/official-request/view/${id}`, { state: communityJobNavigateState }) :communityDesignOrder ? handleOpenDetailsDesignOrder(id, name) : handleOpenViewSalesOrder(id, name)
                      : () => enqueueSnackbar('Access Denied: Moved to installation Phase', { variant: 'error' })
                    : quotationView
                    ? explodedPermissions?.some((permission) =>
                        ['View Estimate', 'Create Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
                      )
                      ? () => handleOpenDetails(id, name)
                      : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                    : designOrder
                    ? explodedPermissions?.some((permission) =>
                        ['View Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                      )
                      // ? () => navigate(`/dashboard/design-order/view/${id}`)
                      ? () => handleOpenDetailsDesignOrder(id, name)
                      : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                    : proposalView
                    ? statusRfp === null || statusRfp === 1
                      ? () => handleOpenViewPurchaseOrder(id, name)
                      : () => enqueueSnackbar('Access Denied: Proposal submission closed', { variant: 'error' })
                      // : () => CommunityJob ? navigate(`/dashboard/official-request/view/${id}`, { state: { fromProjects: true } }) : communityDesignOrder ? navigate(`/dashboard/design-order/view/${id}`) : handleOpenDetailsSalesOrder(id, name)
                      : () => CommunityJob ? navigate(`/dashboard/official-request/view/${id}`, { state: communityJobNavigateState }) : communityDesignOrder ? handleOpenDetailsDesignOrder(id, name) : handleOpenDetailsSalesOrder(id, name)
                  : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
              }
              variant="body2"
              sx={{
                flex: 1,
                fontSize: '13px',
                fontWeight: 500,
                lineHeight: 1.3,
                ml: 1,
                cursor: 'pointer',
                display: 'inline-block',
                ...PRESERVE_WHITESPACE_ELLIPSIS_SX,
                color: theme.palette.mode === 'light' ? '#00a6e7' : theme.palette.primary.main,
                '&:hover': {
                  cursor: CommunityProjects
                    ? explodedPermissions?.some((permission) =>
                        ['Add Jobs', 'Edit Jobs', 'Activate/Deactivate Jobs', 'Delete Jobs', 'Manage Job Cost'].includes(permission)
                      ) || (userType === 3 && status !== 6)
                      ? 'pointer'
                      : 'default'
                    : quotationView
                    ? explodedPermissions?.some((permission) =>
                        ['View Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
                      ) || (userType === 3 && status !== 6)
                      ? 'pointer'
                      : 'default'
                    : designOrder
                    ? explodedPermissions?.some((permission) =>
                        ['View Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                      ) || (userType === 3 && status !== 6)
                      ? 'pointer'
                      : 'default'
                    : explodedPermissions?.some((permission) =>
                        ['Create Request', 'Edit Request', 'Delete request', 'Add vendor to request', 'Add client to request'].includes(permission)
                      ) || (userType === 3 && status !== 6)
                    ? 'pointer'
                    : 'default',
                },
              }}
            >
              <span style={PRESERVE_WHITESPACE_ELLIPSIS_SX}>
                {groupedInvoiceDisplayName}
              </span>
            </Typography>
          </Tooltip>
          {isGroupedInvoiceCard && (
            <Typography
              variant="body2"
              sx={{
                fontSize: '12px',
                fontWeight: 700,
                color: theme.palette.text.primary,
                flexShrink: 0,
                mr: 1,
              }}
            >
              Quantity: {card?.grouped_quantity || String(card?.grouped_request_ids || '').split(',').filter(Boolean).length || 1}
            </Typography>
          )}
          {((userType != 3 && !CommunityProjects) || proposalView) && (
              // <Typography
              // onClick={
              //   CommunityProjects
              //     ? explodedPermissions?.some((permission) =>
              //         [
              //           'Add Jobs',
              //           'Edit Jobs',
              //           'Activate/Deactivate Jobs',
              //           'Delete Jobs',
              //           'Manage Job Cost',
              //         ].includes(permission),
              //       ) || userType == 3
              //       ? () => navigate(PATH_DASHBOARD.project.viewproject + id)
              //       : () =>
              //           enqueueSnackbar(
              //             'Access Denied: You do not have sufficient permissions',
              //             { variant: 'error' },
              //           )
              //     : quotationView
              //       ? (explodedPermissions?.some((permission) =>
              //         ['View Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
              //       ) ||
              //       (userType === 3 && status !== 6)) &&
              //       !(userType === 3 && accept_status === 2)
              //         ? () => handleOpenDetails(id, name)
              //         : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
              //         // ? () => handleOpenDetails(id, name)
              //         // ? () => navigate(`/dashboard/quick-bid/view/${id}`)
              //     : designOrder
              //       ? (explodedPermissions?.some((permission) =>
              //         ['View Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
              //       ) ||
              //       (userType === 3 && status !== 6)) &&
              //       !(userType === 3 && accept_status === 2)
              //       // ? () => navigate(`/dashboard/design-order/view/${id}`)  
              //       ? () => handleOpenDetailsDesignOrder(id, name)
              //         : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
              //     :(explodedPermissions?.some((permission) =>
              //         [
              //           'Edit Request',
              //           'View request',
              //           'Delete request',
              //           'Add vendor to request',
              //           'Add client to request',
              //         ].includes(permission),
              //       ) ||
              //         (userType === 3 && status !== 6)) &&
              //       !(userType === 3 && accept_status === 2)
              //     ? proposalView
              //       ? () => handleOpenDetailsPurchaseOrder(id, name, false)
              //       : // navigate(`/dashboard/rfp/view/${id}`)
              //         () =>
              <Typography
                onClick={(event) => {
                  event.stopPropagation();
                  if (isGroupedInvoiceCard) {
                    handleOpenDetailsSalesOrder?.(id, groupedInvoiceDisplayName, false, true);
                    return;
                  }
                  CommunityProjects
                    ? explodedPermissions?.some((permission) =>
                        [
                          'Add Jobs',
                          'Edit Jobs',
                          'Activate/Deactivate Jobs',
                          'Delete Jobs',
                          'Manage Job Cost',
                        ].includes(permission),
                      ) || userType == 3
                      ? () => navigate(PATH_DASHBOARD.project.viewproject + id)
                      : () =>
                          enqueueSnackbar(
                            'Access Denied: You do not have sufficient permissions',
                            { variant: 'error' },
                          )
                    : quotationView
                      ? (explodedPermissions?.some((permission) =>
                        ['View Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
                      ) ||
                      (userType === 3 && status !== 6)) &&
                      !(userType === 3 && accept_status === 2)
                        ? handleOpenDetails(id, name)
                        : enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                        // ? () => handleOpenDetails(id, name)
                        // ? () => navigate(`/dashboard/quick-bid/view/${id}`)
                    : designOrder
                      ? (explodedPermissions?.some((permission) =>
                        ['View Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                      ) ||
                      (userType === 3 && status !== 6)) &&
                      !(userType === 3 && accept_status === 2)
                      // ? () => navigate(`/dashboard/design-order/view/${id}`)  
                      ? handleOpenDetailsDesignOrder(id, name)
                        : enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                    :(explodedPermissions?.some((permission) =>
                        [
                          'Edit Request',
                          'View request',
                          'Delete request',
                          'Add vendor to request',
                          'Add client to request',
                        ].includes(permission),
                      ) ||
                        (userType === 3 && status !== 6)) &&
                      !(userType === 3 && accept_status === 2)
                    ? proposalView
                      ? handleOpenDetailsPurchaseOrder(id, name, false)
                      : // navigate(`/dashboard/rfp/view/${id}`)
                        CommunityJob ? 
                        navigate(`/dashboard/official-request/view/${id}`, { state: communityJobNavigateState }) :
                        // communityDesignOrder ? navigate(`/dashboard/design-order/view/${id}`) :
                        communityDesignOrder ? handleOpenDetailsDesignOrder(id, name) :
                        handleOpenDetailsSalesOrder(id, name)
                    : enqueueSnackbar(
                        'Access Denied: You do not have sufficient permissions',
                        { variant: 'error' },
                      )
                }}
                variant="body2"
              sx={{
                fontSize: '12px',
                color: theme.palette.primary.main,
                flexShrink: 0,
                mr: 1,

                '&:hover': {
                  cursor: CommunityProjects
                    ? explodedPermissions?.some((permission) =>
                        [
                          'Add Jobs',
                          'Edit Jobs',
                          'Activate/Deactivate Jobs',
                          'Delete Jobs',
                          'Manage Job Cost',
                        ].includes(permission),
                      )
                      ? 'pointer'
                      : 'default'
                    :  quotationView
                    ? (explodedPermissions?.some((permission) =>
                        ['View Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
                      ) ||
                      (userType === 3 && status !== 6)) &&
                      !(userType === 3 && accept_status === 2)
                      ? 'pointer'
                      : 'default'
                    :  designOrder
                    ? (explodedPermissions?.some((permission) =>
                        ['View Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                      ) ||
                      (userType === 3 && status !== 6)) &&
                      !(userType === 3 && accept_status === 2)
                      ? 'pointer'
                      : 'default'
                    :
                    (explodedPermissions?.some((permission) =>
                        [
                          'Edit Request',
                          'View request',
                          'Delete request',
                          'Add vendor to request',
                          'Add client to request',
                        ].includes(permission),
                      ) ||
                        (userType === 3 && status !== 6)) &&
                      !(userType === 3 && accept_status === 2)
                    ? 'pointer'
                    : 'default',
                },
              }}
            >
              {quotationView || proposalView ? 'Details' : 'Details'}
              {/* {quotationView || proposalView ? 'Details' : 'Sales Order Details'} */}
            </Typography>
          )}
        </Stack>
        
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', minHeight: 0 }}>
          <Box sx={{ px: 1.5 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5, gap: 1 }}>
            <Stack
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                mt: 0.5,
                flex: 1,
                minWidth: 0,
              }}
            >
              <Tooltip title={`Last updated ${getAgoString(timestamp)}`}>
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: '10px',
                    color: 'text.secondary',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  Last updated {getAgoString(timestamp)}
                </Typography>
              </Tooltip>


              {designOrder && old_design_order_name ? (
                <Tooltip title={old_design_order_name}>
                <Typography sx={{ fontSize: '10px', color:"#fd6400", border: '1px solid #fd6400', borderRadius: '5px', padding: '2px 5px' }}>
                  {/* {old_design_order_name ? `Copy` : ''} */}           
                  <Typography
                    variant="caption"
                    sx={{
                      fontSize: '10px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems:'center',
                      maxWidth: 120,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    <Icon icon={copyFill} width={12} height={12} style={{ marginRight: 3 }} />
                    <span
                      style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      Duplicated
                    </span>
                  </Typography>
                </Typography>
                </Tooltip>
              ) : ''}

              </Stack>
              
              {avalara_code && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }}>
                  <img
                    src={AVALARALOGO}
                    width={'14px'}
                    height={'11px'}
                  />
                  <Tooltip title={avalara_code}>
                    <Typography sx={{ fontSize: '10px', color:"#fd6400" }}>
                      {avalara_code ? `#${avalara_code}` : ''}
                    </Typography>
                  </Tooltip>
                </Box>
              )}
            </Box>

            {designOrder && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                <Box sx={{ 
                  width: 20, 
                  height: 20, 
                  borderRadius: '50%', 
                  backgroundColor: 'primary.main', 
                  border: '2px solid #80e2ff', 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center',
                  flexShrink: 0
                }}>
                  <Typography sx={{
                    fontWeight: 600,
                    fontSize: '9px',
                    color: '#fff'
                  }}>
                    ID
                  </Typography>
                </Box>
                <Typography sx={{ fontSize: '11px' }}>
                  {id ? `#${id}` : ''}
                </Typography>
              </Box>
            )}
          </Box>

          <Grid
            container
            sx={{
              justifyContent: (syncWithQuickbooks || (isGroupedInvoiceCard && (groupedJobNumbersText || (isGroupedInvoiceApproved && groupedInvoiceNumbersText))))
                ? 'space-between'
                : 'flex-end',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-end',
              gap: 1,
              pb: 1,
              pr: 1.5,
              mt: 'auto',
              flexShrink: 0
            }}
          >
          {(isGroupedInvoiceCard ? (groupedJobNumbersText || (isGroupedInvoiceApproved && groupedInvoiceNumbersText)) : syncWithQuickbooks) ? (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 0.75, flexShrink: 0 }}>
              <img
                src={QuickbookLogo}
                width={44}
                height={22}
                style={{ objectFit: 'contain', display: 'block', flexShrink: 0 }}
              />
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0, textAlign: 'left', justifyContent: 'center' }}>
                {
                  isGroupedInvoiceCard && groupedJobNumbersText ? (
                    <>
                      <Tooltip title={`Job: #${groupedJobNumbersText}`}>
                        <Typography
                          sx={{
                            fontSize: '10px',
                            color: theme.palette.mode === 'light' ? "#53aa00" : "#90EE90",
                            lineHeight: 1.2,
                            maxWidth: 130,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            textAlign: 'left',
                            display: 'block',
                          }}
                        >
                          {`Job: #${groupedJobNumbersText}`}
                        </Typography>
                      </Tooltip>
                      <Typography sx={{ fontSize: '10px', color: theme.palette.mode === 'light' ? "#53aa00" : "#90EE90", lineHeight: 1.2, textAlign: 'left', minHeight: 12 }}>
                        {isGroupedInvoiceApproved && groupedInvoiceNumbersText ? `Inv: #${groupedInvoiceNumbersText}` : ''}
                      </Typography>
                    </>
                  ) :
                  ((doc_number  || installation_acceptance) && est_doc_number) && (doc_number !== est_doc_number) ?
                  <>
                    <Typography sx={{ fontSize: '10px', color: theme.palette.mode === 'light' ? "#53aa00" : "#90EE90", lineHeight: 1.2, textAlign: 'left' }}>
                      {est_doc_number ? `Job: #${est_doc_number}` : ''}
                    </Typography>
                    <Typography sx={{ fontSize: '10px', color: theme.palette.mode === 'light' ? "#53aa00" : "#90EE90", lineHeight: 1.2, textAlign: 'left' }}>
                      {doc_number ? `Inv: #${doc_number}${invoiceSequenceSuffix}` : ''}
                    </Typography>
                  </>
                  :
                  est_doc_number == null ?
                  <Typography sx={{ fontSize: '10px', color: theme.palette.mode === 'light' ? "#53aa00" : "#90EE90", lineHeight: 1.2, textAlign: 'left' }}>
                    {doc_number ? `Inv: #${doc_number}${invoiceSequenceSuffix}` : ''}
                  </Typography>
                  :
                  <Typography sx={{ fontSize: '10px', color: theme.palette.mode === 'light' ? "#53aa00" : "#90EE90", lineHeight: 1.2, textAlign: 'left' }}>
                    {doc_number ? `Job: #${doc_number}` : ''}
                  </Typography>
                }
              </Box>
            </Box>
          ) : (
            ''
          )}

            {hasViewCostPermission && <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              {designOrder ? (
                design_order_total !== null && design_order_total !== undefined ? (
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: '12px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 0.5,
                    }}
                  >
                    <RequestQuote
                      sx={{
                        width: 16,
                        height: 16,
                        color:
                          status === 4
                            ? theme.palette.success.main
                            : theme.palette.error.main,
                      }}
                    />
                    {fUSPrice(design_order_total || 0)}
                  </Typography>
                ) : (
                  <Box sx={{ minHeight: 0 }} />
                )
              ) : (userType === 3 &&
                proposalView &&
                statusRfp === 2 &&
                effectiveInvoiceGrandTotal !== null &&
                effectiveInvoiceGrandTotal !== undefined) ||
              (userType !== 3 &&
                proposalView &&
                awarded &&
                effectiveInvoiceGrandTotal !== null &&
                effectiveInvoiceGrandTotal !== undefined) ? (
                <Typography
                  variant="body2"
                  sx={{ 
                    color: theme.palette.success.main,
                    fontSize: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5
                  }}
                >
                  <RequestQuote
                    sx={{
                      width: 16,
                      height: 16,
                      color: theme.palette.success.main,
                    }}
                  />
                  {fUSPrice(effectiveInvoiceGrandTotal || 0)}
                </Typography>
              ) : (userType === 3 && proposalView && statusRfp !== 2) ||
                (userType !== 3 &&
                  proposalView &&
                  !awarded) ? null : effectiveInvoiceGrandTotal !== null &&
                effectiveInvoiceGrandTotal !== undefined ? (
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5
                  }}
                >
                  <RequestQuote
                    sx={{
                      width: 16,
                      height: 16,
                      color:
                        status === 4
                          ? theme.palette.success.main
                          : theme.palette.error.main,
                    }}
                  />
                  {fUSPrice(effectiveInvoiceGrandTotal || 0)}
                </Typography>
              ) : effectiveInvoiceTotal ? (
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5
                  }}
                >
                  <RequestQuote
                    sx={{
                      width: 16,
                      height: 16,
                      color:
                        status === 4
                          ? theme.palette.success.main
                          : theme.palette.error.main,
                    }}
                  />
                {fUSPrice(effectiveInvoiceTotal || 0)}
                </Typography>
              ) : (
                // <Box sx={{ minHeight: designOrder ? 0 : 20 }} />
                <Box sx={{ minHeight: 20 }} />
              )}
            </Box>}
          </Grid>
        </Box>
      </Box>
      </Card>
    </Box>

      <ConfirmationPopup
        open={openVoidPopup}
        handleClick={isSalesOrder ? handleVoidSalesOrder : handleVoidEstimate}
        handleClose={() => {
          setOpenVoidPopup(false);
          setVoidReason('');
          setVoidReasonError('');
        }}
        message={isSalesOrder ? 'You want to void this Sales Order?' : 'You want to void this Estimate?'}
        warningMessage={isSalesOrder ? 'The order will remain in SignWise with a Void status and will be voided in QuickBooks when applicable.' : 'The estimate will remain in SignWise with a Void status. Linked estimate job operations will be locked until reopened.'}
        loading={loadingVoid}
        showReasonField
        reasonRequired
        reasonLabel="Reason for void"
        reasonValue={voidReason}
        reasonError={voidReasonError}
        onReasonChange={(value) => {
          setVoidReason(value);
          if (voidReasonError) setVoidReasonError('');
        }}
      />

      <ConfirmationPopup
        open={openReopenVoidPopup}
        handleClick={isSalesOrder ? handleReopenVoidSalesOrder : handleReopenVoidEstimate}
        handleClose={() => setOpenReopenVoidPopup(false)}
        message={isSalesOrder ? 'You want to reopen this voided Sales Order? It will be restored to its previous workflow status.' : 'You want to reopen this voided Estimate? It will be restored to its previous workflow status.'}
        loading={loadingReopenVoid}
      />

    </>
  )
}
